module.exports = __webpack_public_path__ + "img/86efc1d.jpg";